import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Save, Receipt } from "lucide-react";
import { billingApi } from "@/lib/api";
import { useLang } from "@/context/LangContext";

export const EMPTY_BILLING = { company: "", address: "", zip_city: "", country: "", vat_id: "" };

const FIELDS = [
  ["company", "Ragione sociale", "Company name", "col-span-2"],
  ["address", "Indirizzo", "Address", "col-span-2"],
  ["zip_city", "CAP e Città", "Postcode and city", ""],
  ["country", "Paese", "Country", ""],
  ["vat_id", "P.IVA / UID", "VAT no. / UID", "col-span-2"],
];

export const useBilling = () => {
  const [billing, setBilling] = useState(EMPTY_BILLING);
  useEffect(() => { billingApi.get().then((b) => setBilling({ ...EMPTY_BILLING, ...b })).catch(() => {}); }, []);
  return [billing, setBilling];
};

export const BillingFields = ({ value, onChange }) => {
  const { tr } = useLang();
  return (
    <div data-testid="billing-fields" className="grid grid-cols-2 gap-3 max-w-3xl">
      {FIELDS.map(([k, it, en, span]) => (
        <label key={k} className={`${span} text-[10px] uppercase tracking-widest font-mono text-[#71717a] space-y-1`}>
          <span>{tr(it, en)}</span>
          <input data-testid={`billing-${k}`} value={value[k] || ""} maxLength={k === "vat_id" ? 40 : 200}
            onChange={(e) => onChange({ ...value, [k]: e.target.value })}
            className="w-full h-11 border border-[#cfd6d9] bg-white px-3 text-sm normal-case tracking-normal font-sans text-[#2B3036] outline-none focus:border-[#2B3036]" />
        </label>
      ))}
    </div>
  );
};

export const BillingCard = () => {
  const { tr } = useLang();
  const [billing, setBilling] = useBilling();
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { setBilling({ ...EMPTY_BILLING, ...(await billingApi.put(billing)) }); toast.success("Dati di fatturazione salvati"); }
    catch { toast.error(tr("Errore salvataggio", "Save error")); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid="billing-card" className="border border-[#e4e4e7] bg-white p-6 space-y-4">
      <div className="flex items-center gap-2">
        <Receipt className="w-4 h-4 text-[#E0262C]" />
        <h2 className="font-display text-xl">Dati di fatturazione</h2>
      </div>
      <p className="text-sm text-[#5b6168] max-w-2xl">Facoltativi: se compilati compaiono sulle prossime fatture. Le fatture già emesse non vengono modificate.</p>
      <BillingFields value={billing} onChange={setBilling} />
      <button data-testid="billing-save" onClick={save} disabled={busy}
        className="inline-flex items-center gap-2 bg-[#2B3036] text-white px-5 h-11 text-sm font-medium hover:bg-[#E0262C] transition-colors disabled:opacity-50">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Salva
      </button>
    </div>
  );
};
